import { render, staticRenderFns } from "./InputText.vue?vue&type=template&id=8923b4fa&scoped=true&"
import script from "./InputText.vue?vue&type=script&lang=js&"
export * from "./InputText.vue?vue&type=script&lang=js&"
import style0 from "@/sass/07_elements/input-text.scss?vue&type=style&index=0&id=8923b4fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8923b4fa",
  null
  
)

export default component.exports